"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockGeneralCatalogItemList_1 = require("./mockGeneralCatalogItemList");
Object.defineProperty(exports, "mockGeneralCatalogItemList", { enumerable: true, get: function () { return mockGeneralCatalogItemList_1.default; } });
//# sourceMappingURL=index.js.map